import type { HelpFile } from '../../types/help'
import { PageLayoutTestIds } from '../../../testids/PageLayoutTestIds'

export const pageLayoutHelp: HelpFile = {
  docPage: '/docs/getting-started/navigation',
  texts: {
    [PageLayoutTestIds.pageLayoutHeader]: null,
    [PageLayoutTestIds.pageLayoutIcon]: null,
    [PageLayoutTestIds.pageLayoutTitle]: null,
    [PageLayoutTestIds.pageLayoutDescription]: null,
    [PageLayoutTestIds.pageLayoutActions]: null,
    [PageLayoutTestIds.pageLayoutCount]: null,
    [PageLayoutTestIds.pageLayoutStats]: null,
    [PageLayoutTestIds.pageLayoutFilters]: null,
    [PageLayoutTestIds.pageLayoutCard]: null,
    [PageLayoutTestIds.pageLayoutContent]: null,
    [PageLayoutTestIds.pageLayoutTabBar]: null,
    [PageLayoutTestIds.pageLayoutTabs]: null,
    [PageLayoutTestIds.pageLayoutWizardNav]: null,
    [PageLayoutTestIds.loadingSkeleton]: null,
    [PageLayoutTestIds.tabPanelHeader]: null,
    [PageLayoutTestIds.tabPanelTitle]: null,
    [PageLayoutTestIds.tabPanelDescription]: null,
    [PageLayoutTestIds.tabPanelCount]: null,
    [PageLayoutTestIds.tabPanelFilters]: null,
    [PageLayoutTestIds.tabPanelContent]: null,
    [PageLayoutTestIds.tabPanelPagination]: null,
  },
}
